module.exports = __webpack_public_path__ + "img/banner-principal-decorativo-2.ac8cf183.svg";